import styled from '@emotion/styled';
import { css } from '@emotion/react';

export const TableWrapper = styled.div(
    ({ theme }) => css`
        margin-bottom: ${theme.spacing['32px']};
    `
);

export const Table = styled.table(
    () => css`
        border-collapse: collapse;
        max-width: 90vw;
        overflow: auto;
        display: block;
    `
);

export const TableHeading = styled.th(
    ({ theme }) => css`
        background: ${theme.colors['grey-alabaster']};
        border: 1px solid ${theme.colors['grey-aluminium']};
        padding: ${theme.spacing['8px']};
        position: sticky;
        text-align: left;
        top: -1px;
    `
);

export const TableData = styled.td(
    ({ theme }) => css`
        border: 1px solid ${theme.colors['grey-aluminium']};
        color: ${theme.colors['grey-steel']};
        padding: ${theme.spacing['8px']};
    `
);

export const TableCaption = styled.caption(
    ({ theme }) => css`
        font-weight: ${theme.type['semiBold']};
        margin-bottom: ${theme.spacing['16px']};
        text-align: left;
    `
);

export const TableDataSource = styled.p(
    ({ theme }) => css`
        color: ${theme.colors['grey-steel']};
        font-size: ${theme.fontSizes['0']};
        margin: ${theme.spacing['16px']} 0 0 0;
    `
);
